<template>
    <div class="inner-page">
        <b-tabs card align="center" v-model="tabIdx">
            <b-tab :title="$translate('Payments')">
                <view-item v-if="!!item" :item="item" @success="resetItems" @cancel="item = false"
                    @delete-item="deleteType"></view-item>

                <list-items v-else @show-item="showItem" ref="table">
                    <!-- <b-button block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                            :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button> -->
                            <b-button block variant="primary"  @click="item = {}"><img v-b-tooltip.hover
                                :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
                </list-items>
        </b-tab>
        <b-tab :title="$translate('activity_transactions')">
            <order-transactions v-if="tabIdx == 1" ref="orderTransactionTable" />
        </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import OrderTransactions from './OrderTransactions'
import ViewItem from './ViewItem'

export default {
    name: 'Payments',
    components: {
        ListItems,
        ViewItem,
        OrderTransactions,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data() {
        return {
            tabIdx: 0,
            item: null,
        }
    },
    computed: {
        componentName(){
            return this.$translate('payments')
        },
        items() {
            const items =this.$store.state.payments.items
            return items
        },
    },
    methods: {
        async doSearch() {
            await this.$store.dispatch('payments/fetchAll')
        },
        showItem(id) {
            console.log('idssss', id)
            this.item = this.items.find(x => x.id === id)
            this.$store.state.payments.item = this.item; 
        
        },
        resetItems(status) {
            this.genericToast(
                this.componentName,
                status,
                'success',
                `${this.componentName} ${status.toLowerCase()} ${this.$translate('succcessfully')}`
            )
            this.item = null
            // this.doSearch()
        },
    },
}
</script>
<style></style>
